import { useScreenSize } from '@/hooks/useScreenSize';
import { useCallback } from 'react';

export const useCalculateIconSize = () => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();

    const calculateIconSize = useCallback(
        (iconSize: { width: number; height: number }) => {
            return {
                width: scaleWidthPixel(iconSize.width),
                height: scaleHeightPixel(iconSize.height),
            };
        },
        [scaleHeightPixel, scaleWidthPixel]
    );

    return { calculateIconSize };
};
